var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropppPayDark = function SvgDropppPayDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "#fff",
    fillOpacity: 0.15,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.069 14.699c-.407 1.774-2.05 2.957-3.824 2.86l1.61-7.084c.703.284 1.3.773 1.718 1.42a3.63 3.63 0 01.496 2.804zm-6.28 5.995a1.544 1.544 0 01-1.166.198 1.532 1.532 0 01-1.164-1.83l1.353-5.926a3.783 3.783 0 013.825-2.93l-2.166 9.53c-.091.4-.333.74-.682.958zm-6.425-3.131l2.166-9.53a1.544 1.544 0 011.848-1.156 1.532 1.532 0 011.163 1.83l-1.352 5.926c-.41 1.793-2.058 3.012-3.825 2.93zm-2.937-1.688a3.63 3.63 0 01-.496-2.804c.407-1.775 2.05-2.958 3.824-2.86l-1.61 7.083a3.676 3.676 0 01-1.718-1.42zm16.197-4.65a4.928 4.928 0 00-3.16-2.158 4.954 4.954 0 00-3.92.857l.215-.943c.34-1.488-.605-2.973-2.105-3.311a2.793 2.793 0 00-2.108.358 2.75 2.75 0 00-1.234 1.733l-.28 1.228c-2.448-.239-4.76 1.366-5.318 3.808a4.85 4.85 0 00.662 3.746 4.926 4.926 0 003.16 2.16c.332.069.665.102.993.102 1.065 0 2.087-.35 2.927-.959l-.215.942c-.34 1.488.605 2.974 2.105 3.312a2.791 2.791 0 002.108-.358 2.752 2.752 0 001.234-1.734l.28-1.227c2.45.238 4.76-1.367 5.319-3.808a4.851 4.851 0 00-.663-3.747z",
    clipRule: "evenodd"
  })));
};
export default SvgDropppPayDark;